import React from 'react';
import logo from '../assets/Logo 1.svg';
import aissystLogo from '../assets/AIssyst_logo 1.svg';
import facebookIcon from '../assets/social/Frame 178.svg';
import twitterIcon from '../assets/social/Frame 179.svg';
import instagramIcon from '../assets/social/Group (1).svg';
import instag from '../assets/social/Group.svg';
import youtubeIcon from '../assets/social/Group (2).svg';

const Footer = () => {
  return (
    <div className="max-w-7xl mx-auto mt-12 px-6 font-inter antialiased text-gray-800">
      <footer className="grid grid-cols-1 lg:grid-cols-[220px_1fr_2fr_280px] items-start gap-9 p-12 lg:px-7 rounded-lg bg-transparent min-h-[120px]" role="contentinfo" aria-label="site footer">
        
        {/* Logo */}
        <div className="flex items-start justify-center" aria-hidden="false">
          <img src={logo} alt="Club logo" className="w-21 h-auto object-contain block" />
        </div>

        {/* Contact */}
        <div className="min-w-[200px] text-center lg:text-left" aria-label="contact information">
          <h4 className="m-0 mb-3 text-sm tracking-wider text-gray-900 font-bold">Contact Info</h4>
          <p className="my-2 text-gray-600 text-sm leading-relaxed">
          Ritush Venugopal<br />
          +1 (203) 512-5740<br />
          rvracquetsports@gmail.com
          </p>
        </div>

        {/* About */}
        <div className="max-w-full lg:max-w-[560px] text-center lg:text-left" aria-label="about me">
          <h4 className="m-0 mb-3 text-sm tracking-wider text-gray-900 font-bold">About Me</h4>
          <p className="m-0 text-gray-600 text-sm leading-relaxed">
            Dedicated coach and future club manager, building a place where tennis inspires every generation.
            Passionate about player development, community events, and creating a welcoming space for players
            of every level to learn and grow.
          </p>
        </div>

        {/* Follow Us */}
        <div className="flex flex-col items-center lg:items-start gap-3" aria-label="follow us">
          <h4 className="m-0 mb-3 text-sm tracking-wider text-gray-900 font-bold">Follow us</h4>
          <div className="flex gap-3 items-center" role="navigation" aria-label="social links">
            
            {/* Facebook */}
            <a className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gray-700 text-white no-underline font-bold text-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-500" href="#" title="Facebook" aria-label="Facebook">
              <img src={facebookIcon} alt="Facebook" className="w-5 h-5" />
            </a>

            {/* X (Twitter) */}
            <a className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gray-700 text-white no-underline font-bold text-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-500" href="#" title="X / Twitter" aria-label="X">
              <img src={twitterIcon} alt="Twitter" className="w-5 h-5" />
            </a>
            <a className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gray-700 text-white no-underline font-bold text-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-500" href="#" title="Instagram" aria-label="Instagram">
              <img src={instag} alt="Instagram" className="w-5 h-5" />
            </a>
            {/* Instagram */}
            <a className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gray-700 text-white no-underline font-bold text-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-500" href="#" title="Instagram" aria-label="Instagram">
              <img src={instagramIcon} alt="Instagram" className="w-5 h-5" />
            </a>

            {/* YouTube */}
            <a className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gray-700 text-white no-underline font-bold text-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-500" href="#" title="YouTube" aria-label="YouTube">
              <img src={youtubeIcon} alt="YouTube" className="w-5 h-5" />
            </a>
          </div>
        </div>
      </footer>
      
      <div className="text-left py-6 text-gray-600 text-sm border-t border-gray-200 mt-6 flex flex-col gap-3">
        <div className="flex items-end gap-1.5 mt-2">
          <span className="text-xs text-gray-500 leading-none">Powered by</span>
          <img src={aissystLogo} alt="AIssyst" className="h-15 w-auto opacity-90 transition-opacity duration-200 mx-1 hover:opacity-100" />
          <span className="text-xs text-gray-500 leading-none">All rights reserved</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
